import { Link } from 'react-router-dom';

const exercicios = [
  {
    slug: 'ancoragem-emocional',
    icone: 'ri-anchor-line',
    titulo: 'Ancoragem Emocional',
    descricao: 'Crie um gatilho físico para acessar calma, foco ou confiança em segundos — sob demanda, sempre que precisar.',
    tempo: '15 min',
    praticantes: '5.129',
    resultado: 'Ansiedade eliminada',
    badge: 'Mais popular',
  },
  {
    slug: 'tecnica-swish-pnl',
    icone: 'ri-flashlight-line',
    titulo: 'Técnica Swish',
    descricao: 'Substitua padrões mentais indesejados — procrastinação, medo, bloqueios — por comportamentos de alta performance.',
    tempo: '10 min',
    praticantes: '3.847',
    resultado: 'Sabotagem removida',
    badge: 'PNL Clínica',
  },
  {
    slug: 'identidade-alta-performance',
    icone: 'ri-shield-star-line',
    titulo: 'Identidade de Alta Performance',
    descricao: 'Reprograme sua identidade central e torne-se naturalmente a pessoa que alcança os resultados que você quer.',
    tempo: '30 min',
    praticantes: '2.891',
    resultado: 'Identidade transformada',
    badge: 'Favorita das alunas',
  },
];

export default function IGExercicios() {
  return (
    <section className="py-20 px-5 bg-gradient-to-b from-luxury-black via-[#0f0e0b] to-luxury-black">
      <div className="max-w-lg mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold-500/10 border border-gold-500/25 rounded-full mb-5">
            <i className="ri-gift-line text-gold-400 text-sm" />
            <span className="text-[11px] font-bold text-gold-400 tracking-[0.18em] uppercase">100% Gratuito · Sem cadastro</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-white leading-tight mb-4">
            Comece agora com <span className="text-gold-400">3 exercícios poderosos</span>
          </h2>
          <p className="text-white/45 text-sm leading-relaxed">
            Experimente o método antes de qualquer compromisso. Acesso imediato, sem precisar cadastrar e-mail.
          </p>
        </div>

        {/* Cards dos exercícios */}
        <div className="space-y-4 mb-8">
          {exercicios.map((ex, i) => (
            <div
              key={i}
              className="relative bg-gradient-to-br from-white/[0.04] to-transparent border border-gold-500/20 rounded-2xl overflow-hidden"
            >
              {/* Linha topo */}
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/40 to-transparent" />

              <div className="p-5">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gold-500/12 border border-gold-500/25 shrink-0">
                    <i className={`${ex.icone} text-2xl text-gold-400`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap mb-1">
                      <h3 className="font-display text-base font-bold text-white leading-tight">{ex.titulo}</h3>
                      <span className="text-[9px] font-bold text-gold-400 bg-gold-500/12 border border-gold-500/20 px-2 py-0.5 rounded-full whitespace-nowrap">
                        {ex.badge}
                      </span>
                    </div>
                    <p className="text-xs text-white/45 leading-relaxed mb-3">{ex.descricao}</p>
                    <div className="flex items-center gap-3 text-[10px] text-white/25 mb-4">
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line text-gold-500/60" />
                        {ex.tempo}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-group-line text-gold-500/60" />
                        {ex.praticantes} praticantes
                      </span>
                    </div>
                    {/* Resultado esperado */}
                    <div className="flex items-center gap-2 bg-emerald-400/[0.07] border border-emerald-400/20 rounded-xl px-3 py-2 mb-4">
                      <i className="ri-checkbox-circle-fill text-emerald-400 text-sm" />
                      <span className="text-xs font-semibold text-emerald-300">Resultado: {ex.resultado}</span>
                    </div>
                    <Link
                      to={`/exercicio-gratis/${ex.slug}`}
                      className="group flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-white/[0.06] border border-white/15 hover:bg-gold-500/12 hover:border-gold-500/30 text-white/75 hover:text-white font-semibold text-sm transition-all cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-play-circle-line text-gold-400 text-base" />
                      Fazer este exercício — grátis
                      <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Link para ver todos */}
        <Link
          to="/exercicios-gratis"
          className="group flex items-center justify-center gap-2.5 w-full py-3.5 rounded-2xl border border-white/10 bg-white/[0.02] hover:bg-white/[0.05] hover:border-gold-500/25 transition-all cursor-pointer"
        >
          <i className="ri-sparkling-2-line text-gold-400/70 text-sm" />
          <span className="text-sm font-medium text-white/40 group-hover:text-white/65 transition-colors">
            Ver todos os 12 exercícios gratuitos
          </span>
          <i className="ri-arrow-right-s-line text-white/25 group-hover:text-gold-400/60 group-hover:translate-x-0.5 transition-all" />
        </Link>
      </div>
    </section>
  );
}
